import { mapState, mapActions } from 'vuex';
import cstmTable from '../../../share/components/vue/PaginationTable';
import diagnoseResource from "../../../share/util/diagnose";
import { computeObdOmtDTCTableItem } from '../../../util/obd/diag';

export default {
  name: 'detailMonitorTestModal',
  data() {
    return {
      displayTableInfo: [],
      monitorTestResultColumns: [],
    };
  },

  components: {
    'cstm-table-modal': cstmTable,
  },

  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('cache', ['cacheProjectDetails']),

    /**
     * モニタテスト 一覧の生成
     */
    async updateDetailMonitorTestTable(monitorTestData, immutableId) {
      // 共通カラムを定義
      const tableInfo = [
        { name: 'scaling_id', label: 'individual.label_table_scaling_id' },
        { name: 'test_value', label: 'individual.label_table_value' },
        { name: 'unit', label: 'individual.label_table_unit' },
        { name: 'minimum_test_limit', label: 'individual.label_table_min' },
        { name: 'maximum_test_limit', label: 'individual.label_table_max' },
        { name: 'result', label: 'individual.label_table_result' }
      ];

      // 条件に応じて特定のカラムを先頭に追加
      if (immutableId === 4501) {
        tableInfo.unshift(
          { name: 'mid', label: 'individual.label_table_mid' },
          { name: 'tid', label: 'individual.label_table_tid' }
        );
      } else {
        tableInfo.unshift(
          { name: 'status', label: 'message.header_vehicle_dtc_table_status' },
          { name: 'code', label: 'message.header_vehicle_dtc_table_code', originalSortFunc: diagnoseResource.sortFuncCode },
          { name: 'description', label: 'message.header_vehicle_dtc_table_description', useResource: true, originalSortFunc: diagnoseResource.sortFuncDescription }
        );
      }

      // カラムを設定
      this.monitorTestResultColumns = tableInfo;

      // テーブルデータを設定
      this.displayTableInfo = computeObdOmtDTCTableItem(monitorTestData, immutableId === 12501, this);
    },
  },

  computed: {
    ...mapState({
      cachedDetails: state => state.cache.projectDetails
    }),
  },

  /** createdイベント */
  created() {
    // noop
  },

  /** mountedイベント */
  mounted() {
    // noop
  },
};